import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';

export const SelectField = ({ label, name, control, errors = {}, options = [], placeholder = '', controlclass = '', required = false, ...rest }) => {
  const isInvalid = !!errors?.[name];
  return (
    <Form.Group controlId={name} className={controlclass}>
      {label && <Form.Label>{label} {required && <span className="text-danger">*</span>}</Form.Label>}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Form.Select
            {...field}
            isInvalid={isInvalid}
            {...rest}
          >
            {placeholder && <option value="">{placeholder}</option>}
            {options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Form.Select>
        )}
      />
      <Form.Control.Feedback type="invalid">
        {errors?.[name]?.message}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

SelectField.propTypes = {
  label: PropTypes.node,
  name: PropTypes.string.isRequired,
  control: PropTypes.object, // from react-hook-form useForm().control
  errors: PropTypes.object,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  controlclass: PropTypes.string,
};

